module.exports = __webpack_public_path__ + "img/stop-sign.426ae91c.png";